import React,{useState} from "react";
import {Button,Form,Table} from "react-bootstrap";
import {forecastComparisonRows} from "./rsoHistoryHelpers";
import {useRsoHistory} from "./useRsoHistory";

const monthLabel = (month) => new Date(`${month.slice(0,7)}-01T12:00:00`).toLocaleDateString(undefined,{month:"long",year:"numeric"});
const comparisonValue = (value,items) => items?.length ? <ul className="rsf-comparison-list">
  {items.map((item,index) => <li key={index}>{item}</li>)}
</ul> : value;
export const ForecastComparison = ({before,after,heading}) => <section className="rsf-changes" aria-label={heading}>
  {heading && <h6>{heading}</h6>}
  <div className="rsf-comparison-scroll"><Table size="sm" className="rsf-comparison mb-0">
    <thead><tr><th>Changed</th><th>Before</th><th>After</th></tr></thead>
    <tbody>{forecastComparisonRows(before,after).map((row) => <tr key={row.key} className={row.before !== row.after ? "rsf-changed-row" : undefined}>
      <th scope="row">{row.label}{row.note && <small className="d-block fw-normal">{row.note}</small>}</th>
      <td>{comparisonValue(row.before,row.beforeItems)}</td><td>{comparisonValue(row.after,row.afterItems)}</td>
    </tr>)}</tbody>
  </Table></div>
</section>;

export default function RsoChangeHistory({property,month,token,reloadKey,label="Change history"}) {
  const [open,setOpen] = useState(false);
  const [allMonths,setAllMonths] = useState(false);
  const history = useRsoHistory({enabled:open,token,contactInfoId:property.contactInfoId,
    forecastMonth:allMonths ? null : `${month}-01`,reloadKey});
  const panelId = `rsf-history-${property.contactInfoId}`;
  return <section className="rsf-history" aria-label={`Change history for ${property.propertyName}`}>
    <Button variant="link" aria-expanded={open} aria-controls={panelId} onClick={() => setOpen((value) => !value)}>{label}</Button>
    {open && <div id={panelId}>
      <h6>Saved changes for {property.propertyName}</h6>
      <p>Monthly RSO forecasts only. This does not change the property&apos;s flooring setup.</p>
      <Form.Group controlId={`${panelId}-month`}>
        <Form.Label>Show changes for</Form.Label>
        <Form.Select value={allMonths ? "all" : "month"} onChange={(event) => setAllMonths(event.target.value === "all")}>
          <option value="month">{monthLabel(month)}</option><option value="all">All months</option>
        </Form.Select>
      </Form.Group>
      {history.items.map((event) => {
        const date = new Date(event.savedAt);
        const savedAt = event.savedAt && !Number.isNaN(date.getTime()) ? date.toLocaleString() : "Time not recorded";
        return <article className="rsf-history-entry" key={event.id}>
          <h6>{monthLabel(event.forecastMonth)} · Saved by {event.submittedBy?.displayName || "Not recorded"}</h6>
          <p><time dateTime={event.savedAt || undefined}>{savedAt}</time></p>
          {event.legacy && <p>Older forecast. Some details were not recorded.</p>}
          <ForecastComparison before={event.before} after={event.after} />
        </article>;
      })}
      {history.status === "loading" && <p role="status">Loading change history…</p>}
      {history.status === "error" && <div role="status"><p>Could not load change history. Your draft is unchanged.</p><Button variant="outline-secondary" onClick={history.retry}>Try history again</Button></div>}
      {history.status === "ready" && history.items.length === 0 && <p>No saved changes {allMonths ? "yet" : "for this month"}.</p>}
      {history.nextCursor && <Button variant="outline-secondary" disabled={history.status !== "ready"} onClick={history.loadMore}>Load more</Button>}
    </div>}
  </section>;
}
